<template>
    <pt-dropdown
        :max-height="300"
        trigger="click"
        @command="handleFilterCommand"
        :class="$style.filter"
    >
        <pt-button
            size="normal"
            color="dark"
            type="text"
            :iconAfter="{
                name: 'PTX-icon-select-12',
                width: '12px',
                height: '12px'
            }"
        >
            <span :class="$style.label"
                ><span style="margin-right: 10px">{{ props.label }}</span>
                {{ $t(activeFilter[props.textKey]) }}</span
            >
        </pt-button>
        <template #dropdown>
            <pt-dropdown-menu>
                <pt-dropdown-item
                    v-for="item in props.options"
                    :key="item[props.valueKey]"
                    :command="item"
                >
                    {{ $t(item[props.textKey]) }}
                </pt-dropdown-item>
            </pt-dropdown-menu>
        </template>
    </pt-dropdown>
    
</template>

<script lang="ts">
export default {
    name: 'Filter'
};
</script>

<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';
import type { TypeItem } from '@experience/static/config/experience.type';
interface Props {
    label?: string;
    options: TypeItem[];
    defaultFilter?: TypeItem;
    valueKey?: string; // key 作为标识使用
    textKey?: string; // name 显示使用
}
const emit = defineEmits(['filter']);
const props = withDefaults(defineProps<Props>(), {
    valueKey: 'key',
    textKey: 'name'
});
const activeFilter = ref<TypeItem>(props.options[0]);
onMounted(() => {
    if (props.defaultFilter) {
        activeFilter.value = props.defaultFilter;
    }
});

watch(
    () => props.defaultFilter,
    () => {
        props.defaultFilter && (activeFilter.value = props.defaultFilter);
    },
    {
        deep: true,
        immediate: true
    }
);

function handleFilterCommand(command: TypeItem) {
    activeFilter.value = command;
    emit('filter', command);
}
</script>

<style lang="scss" module>
.filter {
    .label {
        line-height: 33px;
        color: #344563;
    }
    :global {
        .pt-button--icon-wrapper {
            margin-top: 4px;
        }
    }
}
</style>
